import React, { useContext } from 'react'
import { Button, Collapse, Flex } from 'antd'
import PublicContext from '../../PublicContext'
import CollapseContent from './CollapseContent'
import { useNavigate } from 'react-router'
import { Color } from '../../../Common/Color'
import defineDate from './defineDate'

export default function PublicSiderXS () {
  const { box, appointment, isNow, params, siderDisabled, siderTitle } = useContext(PublicContext)
  const navigate = useNavigate()

  const date = defineDate(isNow, params, appointment?.begin_date)

  const buttonStyle = (specialist) => {
    if ((location.href.includes('specialist') && specialist) || (!location.href.includes('specialist') && !specialist)) {
      return { color: Color.red, borderColor: Color.red, width: '250px', margin: 'auto' }
    } else {
      return { width: '250px', margin: 'auto' }
    }
  }

  return (
    <>
      <Flex vertical gap='10px' style={{ marginBottom: '1em' }}>
        <div className='LayoutSentence' style={{ fontSize: '20px', fontWeight: 'bold' }}>
          {siderTitle}
        </div>
        {
          !appointment && <>
            <Button onClick={() => { navigate(`/box/${box.id}`) }} style={buttonStyle(false)}>Médecins généralistes</Button>
            { box?.teleconsulting_company_name === 'Tessan' &&
              <Button onClick={() => { navigate(`/box/${box.id}/specialist`) }} style={buttonStyle(true)}>Médecins spécialistes</Button>
            }
          </>
        }
      </Flex>
      <Collapse style={{ marginBottom: '1em' }}
        items={[{ key: 'Informations', label: 'Informations', children: <CollapseContent box={box} appointment={appointment} date={date} isNow={isNow} siderDisabled={siderDisabled} /> }]}
      />
    </>
  )
}
